import script from "./PeopleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleCard.vue?vue&type=script&setup=true&lang=js"

import "./PeopleCard.vue?vue&type=style&index=0&id=61be2f7e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61be2f7e"]])

export default __exports__